import React, { Component } from "react";
import { View, Dimensions, PixelRatio } from "react-native";
import Text from "@components/AppText";
import Checkbox from "@react-native-community/checkbox";
import CustomTextInput from "./CustomTextInput";
import Button from "@components/Button";
import SuccessModal from "@screens/RejectedCl/Success";
import Success from "./Success";
import { undiscardMe, unSuspendMe } from "@services/api";
import BackButton from "@components/BackButton";

const { width, height } = Dimensions.get("window");
const scale = width / 360;

function normalize(size) {
  const newSize = size * scale;
  return Math.round(PixelRatio.roundToNearestPixel(newSize));
}

class RaiseTicket extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: false,
      input: "",
      visible: false,
      isSubmitting: false,
    };
  }

  _onChecked = (val) => {
    this.setState({ checked: val });
  };

  _onChangeText = (text) => {
    this.setState({ input: text });
  };

  _onSubmit = () => {
    this.setState({ isSubmitting: true });
    this?.props?.route?.params?.isLeaderSuspended
      ? unSuspendMe({
          reason: this.state.input,
        })
          .then((_) => {
            this.setState({
              isSubmitting: false,
              visible: true,
            });
          })
          .catch(() => {
            this.setState({
              isSubmitting: false,
              visible: false,
            });
          })
      : undiscardMe({
          reason: this.state.input,
        })
          .then((_) => {
            this.setState({
              isSubmitting: false,
              visible: true,
            });
          })
          .catch(() => {
            this.setState({
              isSubmitting: false,
              visible: false,
            });
          });
  };

  render() {
    return (
      <View style={{ flex: 1 }}>
        <SuccessModal
          visible={this.state.visible}
          onPress={() =>
            this?.props?.route?.params?.isLeaderSuspended
              ? this.props.navigation.goBack()
              : this.props.navigation.navigate("Reject")
          }
          message="हमारे कस्टमर सपोर्ट अधिकारी बहुत जल्दी आप से संपर्क करेंगे I"
        />
        <View
          style={{
            backgroundColor: "white",
            height: 70,
            width: "100%",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <BackButton onPress={() => this.props.navigation.goBack()} />
          <Text
            bold
            style={{
              fontSize: normalize(16),
              lineHeight: normalize(21),
              // marginLeft: 5,
            }}
          >
            Raise support ticket
          </Text>
        </View>
        <CustomTextInput
          value={this.state.input}
          onChange={this._onChangeText}
          height={normalize(120)}
          width={width * 0.9}
          contentContainerStyle={{
            marginBottom: normalize(10),
            alignSelf: "center",
            marginTop: normalize(40),
          }}
        />
        <View
          style={{
            flexDirection: "row",
            marginLeft: width * 0.04,
            alignItems: "center",
          }}
        >
          <Checkbox
            tintColors={{ true: "black" }}
            value={this.state.checked}
            onValueChange={this._onChecked}
          />
          <Text style={{ fontSize: normalize(14), marginleft: 10 }}>
            हाँ, मैं सिटी मॉल के साथ फिर से काम करना चाहता हूँ I
          </Text>
        </View>
        <Button
          disabled={!this.state.checked}
          btnText="Submit"
          onPress={this._onSubmit}
          buttonFontType="bold"
          fontSize={normalize(18)}
          buttonWidth={width * 0.88}
          isSubmitting={this.state.isSubmitting}
          height={normalize(50)}
          borderRadius={10}
          containerStyle={{ alignSelf: "center", marginTop: normalize(40) }}
        />
      </View>
    );
  }
}

export default RaiseTicket;
